import reducer, { SystemStateMessageState } from "./reducers";
import * as systemStateMessageOperations from './operations';
export {
  SystemStateMessageState,
  systemStateMessageOperations
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/systemStateMessage/index.ts